import { Box, BoxProps } from '@mui/material';
import jsonExport from 'jsonexport/dist';
import { Fragment, memo } from 'react';
import { BooleanField, BulkDeleteButton, BulkDeleteButtonProps, BulkExportButton, BulkExportButtonProps, Datagrid, DateField, downloadCSV, List, ReferenceField, SearchInput, ShowButton, ShowView, SimpleShowLayout, TextField, TextInput } from 'react-admin';
import ContextShowButton from '../../Components/ContextShowButton';
import { LoginAsButton } from '../../Components/LoginAsButton';
import CompanyFilterInput from './CompanyFilterInput';

const ProfilesListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const ProfilesListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (profiles: any[]) => {
  return jsonExport(profiles, (err: Error, csv: string) => downloadCSV(csv, 'profiles'));
};
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const ProfilesPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="fullName" cellClassName="fullName" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
      </SimpleShowLayout>
    </ShowView>
  );
};

const profilesFilter = [<SearchInput source="fullName" alwaysOn />, <CompanyFilterInput source="company" label="Company" alwaysOn />, <TextInput source="id" defaultValue="" />, <TextInput source="uuid" defaultValue="" />];

const ProfilesList: React.FC = () => {
  return (
    <List filters={profilesFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<ProfilesListBulkActions />} rowClick={rowClick} expand={ProfilesPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="fullName" cellClassName="fullName" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
        <DateField source="employeeStatusChangedAt" sortByOrder="DESC" />
        <ReferenceField label="Company" source="company" reference="companies">
          <ContextShowButton resource="companies" label="name" />
        </ReferenceField>
        <BooleanField source="active" sortable={false} />
        <LoginAsButton fullNameSource="user.fullName" />
        <ProfilesListActionToolbar>
          <ShowButton />
        </ProfilesListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default ProfilesList;
